import { Navigate, useLocation } from 'react-router-dom';

export function DealerLeadsAliasRedirect() {
  const location = useLocation();
  return (
    <Navigate
      to={{
        pathname: '/dealer-management',
        search: location.search,
        hash: location.hash,
      }}
      replace
    />
  );
}
